import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-stream',
  templateUrl: './stream.component.html',
  styleUrls: ['./stream.component.css']
})
export class StreamComponent implements OnInit {

  id: any;
  movie: any = [];
  stream: any = [];
  eventId: any;
  streamLink: any;
  description: any;
  prevUrl: any;
  canUserAccessMovie: any;
  message: any;
  iframeid1: any;
  movieName: any;
  startDate: any;
  purchaseDate: any;

  constructor(public ShowcasesService: ShowcaseService, 
    private sanitizer: DomSanitizer, private route: ActivatedRoute, 
    private renderer: Renderer2,
    private _location: Location,
  private router: Router) {
    this.id = route.snapshot.params.id;
    this.movieName = route.snapshot.params['movieName'];
  }

  ngOnInit(): void {
    this.getShowcaseList(this.id);
    this.getStream(this.id);
 // screen.orientation.lock('landscape');
  }
  getShowcaseList(id) {
      // cms data
      this.ShowcasesService.ShowcaseGetEventById(this.id).subscribe((res) => {
        this.movie = res;
        this.startDate = new Date(this.movie.eventTime).getTime()    
      });
   
  }

  getStream(eventId: any) {
    const currentDate = Date.now();
    this.ShowcasesService.getMovieStream(eventId,'SHOWCASE').subscribe(res => {
      this.stream = res;
      this.purchaseDate = new Date(this.stream.purchaseDate).getTime()
      this.streamLink = 'https://vimeo.com/showcase/' + this.stream['StreamingID'] + '/embed';
      this.iframeid1 = this.streamLink;
      this.description = this.stream.description;
      if (sessionStorage.getItem('prevUrl') && sessionStorage.getItem('prevUrl') != "" && sessionStorage.getItem('prevUrl') != null) {
        this.prevUrl = sessionStorage.getItem('prevUrl');
      } else {
        this.prevUrl = "/cinejoy/showcase/";
        sessionStorage.setItem('prevUrl', "/cinejoy/showcase/");
      }
      if (res.Error == "You do not have access to the movie") {
        this.canUserAccessMovie = false;
        this.message = "You do not have access to the movie. <a href=/cinejoy/showcase/moviepage/"+this.id+"/"+this.movieName+"/"+this.movie?.cinejoyYears+">Click here </a>to purchase the movie"
      } 
      // else if (this.purchaseDate < this.startDate) {
      //   this.canUserAccessMovie = false;
      //   this.message = "Movie Viewing to occur March 24 - March 31 2025" ;
      // }
       else if (res.AccessStatus == 'AccessValid') {
        let url = `https://vimeo.com/showcase/${this.stream.StreamingID}/embed`;
        this.streamLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.canUserAccessMovie = true;
      } else if (res.AccessStatus == 'AccessExpired') {
        this.canUserAccessMovie = false;
        this.message = "Your access to this movie is expired. Please purchase the movie again.";
      }

    },
      error => { console.log(error);
        this.canUserAccessMovie = false;
        this.message = "You do not have access to the movie. <a href=/cinejoy/showcase/moviepage/"+this.id+"/"+this.movieName+"/"+this.movie?.cinejoyYears+">Click here </a>to purchase the movie"
    }
    );
  }
  
  backClicked() {
    this._location.back();
  }
  
}